module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "group-panel"
  }, [_c('div', {
    staticClass: "group-heading",
    class: {
      collapsed: _vm.collapsed
    },
    on: {
      "click": _vm.toggleCollapse
    }
  }, [_c('div', {
    staticClass: "group-heading-label"
  }, [_c('v-icon', {
    staticClass: "collapse-button",
    class: {
      collapsed: _vm.collapsed
    },
    staticStyle: {
      "margin-top": "-3px"
    },
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-chevron-up")]), _vm._v("\n             " + _vm._s(_vm.schema.label) + "\n            "), (_vm.summary && _vm.collapsed) ? _c('div', {
    staticClass: "summary-text"
  }, [_vm._v(" (" + _vm._s(_vm.summary) + ")")]) : _vm._e()], 1)]), _vm._v(" "), _c('v-expand-transition', [(_vm.schema && !_vm.collapsed) ? _c('div', {
    staticClass: "expanded-area",
    staticStyle: {
      "border-top": "solid 1px #ddd"
    }
  }, [(!_vm.schema.fields) ? _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, _vm._l((_vm.schema.columns), function(columnSchema, csIndex) {
    return _c('div', {
      key: csIndex,
      staticClass: "form-block"
    }, [_c('FormBlock', {
      attrs: {
        "horizontal": _vm.schema.horizontal,
        "schema": columnSchema,
        "value": _vm.value,
        "context": _vm.context
      },
      on: {
        "change": _vm.emitChanges
      }
    })], 1)
  }), 0) : _vm._e(), _vm._v(" "), (_vm.schema.fields) ? _c('div', {
    staticClass: "form-block"
  }, [_c('FormBlock', {
    attrs: {
      "horizontal": _vm.schema.horizontal,
      "schema": _vm.modifiedSchema,
      "value": _vm.value,
      "context": _vm.context
    },
    on: {
      "change": _vm.emitChanges
    }
  })], 1) : _vm._e()]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4dc0f7f1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/forms/blocks/SectionControl.vue
// module id = 2537
// module chunks = 1